import React, { Component, PropTypes } from 'react';
import CaseElement from '../../components/case/caseElementGeneric';

import * as helper from './livehelper';

export default class LiveJudgingCase extends Component {
	static propTypes = {
		item: PropTypes.object.isRequired,
		rank: PropTypes.number.isRequired,
		browser: PropTypes.object.isRequired,
		isTop: PropTypes.bool.isRequired,
		divideAt: PropTypes.number.isRequired,
	};

	static defaultProps = {
		isTop: false,
	};

	constructor(props) {
		super();

		this.timer = 0;
		this.color = '#' + Math.floor(Math.random() * 16777215).toString(16);

		this.state = {
			rank: props.rank,
			prevRank: props.rank,
			goingUp: false,
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.rank !== this.props.rank) {
			this.setState({
				...this.state,
				rank: nextProps.rank,
				prevRank: this.props.rank,
				goingUp: (nextProps.rank < this.props.rank),
				isTransitioning: (nextProps.rank < this.props.rank),
			});
		}
	}

	componentWillUnmount() {
		clearTimeout(this.timer);
	}

	render() {
		let style = {};

		if (helper.DEBUG) {
			style.backgroundColor = this.color;
		}

		let bp = helper.getBreakpoint(this.props.browser);
		let colNumber = helper.getColNumber(bp);
		let rankColOffset = helper.getRankColOffset(this.state.rank, this.props.divideAt, colNumber);

		let row = helper.getRow(this.state.rank, colNumber, rankColOffset);
		let col = helper.getCol(this.state.rank, colNumber, rankColOffset);
		let elDims = helper.getElementDimensions(bp);

		let splitterOffset = (this.state.rank > this.props.divideAt) ? helper.getSplitterOffset(bp) : 0;

		let topOffset = (row * elDims.h) + splitterOffset;
		let leftOffset = (col * elDims.w);

		if (bp === helper.BP_MOBILE_LARGE || bp === helper.BP_MOBILE_SMALL) {
			if (this.state.rank > 1) {
				topOffset += 70;
			}
		}

		style.transform = `translate3d(${leftOffset}px, ${topOffset}px, 0px)`;

		// console.log(`row: ${row} --- col: ${col}`);
		let itemClass = 'live-judging__grid__item';
		//itemClass += ' live-judging__grid__item--transition'; //tmp
		let isTransitioning = this.state.isTransitioning;
		if (isTransitioning) {
			itemClass += ' live-judging__grid__item--transition';
			style.zIndex = 10;

		}

		if (this.state.prevRank !== this.state.rank) {
			this.state.prevRank = this.state.rank;
			this.setNextRank(isTransitioning);
		}

		return (
			<div className={itemClass} style={style}>
				<div className='live-judging__grid__item__mvmt-overlay'>
					<div className='live-judging__grid__item__mvmt-overlay__info'>{this.props.item.points}</div>
					<div className='live-judging__grid__item__mvmt-overlay__info'>{(this.state.goingUp) ? 'Up' : 'Down'}</div>
				</div>
				<CaseElement ref='caseElement' caseItem={this.props.item} browser={this.props.browser} showPoints={true} showJudges={true} contentComp={false} />
			</div>
		);
	}

	setNextRank(isTransitioning) {
		this.timer = setTimeout(() => {
			this.setState({
				...this.state,
				isTransitioning: false,
			});
		}, helper.ANIMATION_DURATION);

		// this.setState({
		// 	...this.state,
		// 	rank: this.state.nextRank,
		// 	isTransitioning: isTransitioning,
		// });
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/containers/livejudging/liveJudgingCase.js
 **/